/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SendResetPasswordMailRequest
 */
export interface SendResetPasswordMailRequest {
  /**
   *
   * @type {string}
   * @memberof SendResetPasswordMailRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof SendResetPasswordMailRequest
   */
  userName: string
}

/**
 * Check if a given object implements the SendResetPasswordMailRequest interface.
 */
export function instanceOfSendResetPasswordMailRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'userName' in value

  return isInstance
}

export function SendResetPasswordMailRequestFromJSON(
  json: any,
): SendResetPasswordMailRequest {
  return SendResetPasswordMailRequestFromJSONTyped(json, false)
}

export function SendResetPasswordMailRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SendResetPasswordMailRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    userName: json['user_name'],
  }
}

export function SendResetPasswordMailRequestToJSON(
  value?: SendResetPasswordMailRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    user_name: value.userName,
  }
}
